module.exports = __webpack_public_path__ + "static/media/Map-icon.6eb98929.svg";